export default __webpack_public_path__ + "static/panc-5ed9d4ab42134445444f7689d5fcbdaf.png";